// extracted by mini-css-extract-plugin
var _1 = "_customerManagementCustomerCollateralTable-module__button-container";
var _2 = "_customerManagementCustomerCollateralTable-module__container";
var _3 = "_customerManagementCustomerCollateralTable-module__danger";
var _4 = "_customerManagementCustomerCollateralTable-module__transaction-action-label";
export { _1 as "button-container", _2 as "container", _3 as "danger", _4 as "transaction-action-label" }
